window.Mark = require('mark.js')
